import { type WipLimitAttributes } from './generated/WipLimitAttributes';
import ApplicationModel, { attr } from '../ApplicationModel';
import { model } from '../modelBuilder';

interface WipLimit extends WipLimitAttributes {}

@model
class WipLimit extends ApplicationModel {
  // Start auto-generated
  static typename: 'WipLimit' = 'WipLimit';
  get typename(): 'WipLimit' {
    return 'WipLimit';
  }

  static fields = {
    limit: attr({ readable: true }),
    workflowStatusId: attr({ readable: true }),
  };
  // End auto-generated

  /**
   * This is a readonly field in the graphql schema, but we need to be able to
   * set it for writing in the parent record
   */
  set limit(newLimit: number) {
    this.setAttribute('limit', newLimit);
  }
}

export default WipLimit;
